/* Hide the internal box item and add-on products from shop grids and search. They are only sold through Build your box and the cart upsell. */
(function () {
  var HIDDEN = ['/products/dirty-vanilla-box-item', '/products/midnight-mocha-add-on'];
  function inCart(el) { return el.closest('[class*="cart"],[id*="cart"],cart-items-component'); }
  function distinct(el) {
    var set = {};
    el.querySelectorAll('a[href*="/products/"]').forEach(function (x) { set[(x.getAttribute('href') || '').split('?')[0]] = 1; });
    return Object.keys(set).length;
  }
  function sweep() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split('?')[0];
      if (HIDDEN.indexOf(h) === -1 || inCart(a)) return;
      var box = a.closest('li, article, [class*="pcard"], [class*="product-card"], [class*="card"]');
      /* Only hide a wrapper that holds just this one product, never a whole grid. */
      if (!box || distinct(box) > 1) box = a;
      box.style.display = 'none';
    });
  }
  sweep();
  new MutationObserver(sweep).observe(document.documentElement, { childList: true, subtree: true });
})();
